import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

// TODO: When Subscription Report has been NgFactored then we can load by a lazy loaded module
@Injectable({
    providedIn: 'root'
})
export class MessageFilterService {

    constructor(private httpClient: HttpClient) {
    }

    getDestinatorFiltersByPersonId(personId: number): Observable<Array<any>> {
        return this.httpClient
            .get(`servlets/messagefilter/${personId}/destinatorfilters/`, {observe: 'body'})
            .pipe(
                map((response: any) => response.destinatorFilters)
            );
    }

    updateDestinatorFilters(destinators: Array<any>, destinatorFilterIds: Array<number>): Observable<any> {
        return this.httpClient
            .post('servlets/messagefilter/destinatorfilters/', {
                destinators,
                destinatorFilterIds});
    }

    /*deleteDestinatorFilter(destinatorFilterId: number): Observable<any> {
        return this.httpClient
            .delete(`servlets/messagefilter/destinatorfilters/${destinatorFilterId}/`);
    }

    addDestinatorFilter(destinators: Array<any>): Observable<any> {
        return this.httpClient
            .post('servlets/messagefilter/destinatorfilters/', { destinators })
            .pipe(
                map((response: any) => response.error)
            );
    }*/
}
